import axios from 'axios';
import {clearAlerts, setAlert} from './alert';
import {getParams} from '../utils/hooks/getParams';
import {
    ADD_SALE,
    CLEAR_ERRORS, GET_CLIENT_OPTIONS,
    GET_PRODUCT_CLIENT_AND_SELLER_ID_DATA,
    GET_SALE, GET_SALE_PRODUCT_OPTIONS,
    GET_SALES, GET_SPECIAL_CLIENT, GET_SPECIAL_SUPPLIER_MATERIALS,
    REMOVE_DELETE_SALE,
    REMOVE_UPDATE_SALE,
    SALE_ERROR,
    SET_DELETE_SALE_ID, SET_LOADING,
    SET_UPDATE_SALE_ID
} from './types';

export const getProductClientSellerIdData = () => async (dispatch) => {

    try {
        const res = await axios.get(`/products?is_all=true`);
        const res2 = await axios.get(`/clients?is_all=true`);
        const res3 = await axios.get(`/users?is_all=true`);

        dispatch({
            type: GET_PRODUCT_CLIENT_AND_SELLER_ID_DATA,
            payload: {
                product_ID_DATA: res.data.data,
                client_ID_DATA: res2.data.data,
                seller_ID_DATA: res3.data.data,
            },
        });

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const getProductOptions = (filters = {}) => async (dispatch) => {
    let queryParams = '';
    if (filters) {
        Object.keys(filters).map((key => queryParams += `&${key}=${filters[key]}`));
    }
    try {
        const res = await axios.get(`/products?is_all=true${queryParams}`);
        dispatch({
            type: GET_SALE_PRODUCT_OPTIONS,
            payload: res.data,
        });

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const getClientOptions = (filters = {}) => async (dispatch) => {
    try {
        let queryParams = '';
        if (filters) {
            Object.keys(filters).map((key) => queryParams += `&${key}=${filters[key]}`);
        }
        const res = await axios.get(`/clients?is_all=true${queryParams}`);
        dispatch({
            type: GET_CLIENT_OPTIONS,
            payload: res.data,
        });

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const getSale = (saleID) => async (dispatch) => {

    try {
        // Check URL for with_trashed_items parameter
        const urlParams = new URLSearchParams(window.location.search);
        const withTrashedItems = urlParams.get('with_trashed_items');
        
        let url = `/sales/${saleID}`;
        if (withTrashedItems === 'true') {
            url += '?with_trashed_items=true';
        }
        
        const res = await axios.get(url);
        dispatch({
            type: GET_SALE,
            payload: res.data,
        });

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const downloadSaleDocument = (saleID, textColor = '#000000') => async (dispatch) => {

    try {
        const response = await axios.get(`/sales/${saleID}/download_document`, {
            params: { text_color: textColor }
        });
        return response.data;
    } catch (err) {
        dispatch(setAlert("Yuklashda muommo bo'ldi!", 'danger'));
    }
};

export const getSpecialClientMaterialTransactions = (id) => async (dispatch) => {

    try {
        const res = await axios.get(`/suppliers/${id}/material-balances`);
        dispatch({
            type: GET_SPECIAL_SUPPLIER_MATERIALS,
            payload: res.data,
        });

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};
export const getSpecialSupplierMaterialTransactions = (id) => async (dispatch) => {

    try {
        const res = await axios.get(`/suppliers/${id}/material-balances`);
        dispatch({
            type: GET_SPECIAL_CLIENT,
            payload: res.data,
        });

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const getSales = (page = 1, filters = {}) => async (dispatch) => {
    dispatch({type: SET_LOADING, payload: true})
    try {

        let queryParams = '';
        if (filters) {
            Object.keys(filters).map((key) => queryParams += `&${key}=${filters[key]}`);
        }
        const res = await axios.get(`/sales?page=${page}${queryParams}`);

        dispatch({
            type: GET_SALES,
            payload: res.data,
        });
        dispatch({type: SET_LOADING, payload: false})
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const addSale = (formData) => async (dispatch) => {
    dispatch(clearAlerts());
    dispatch({type: SET_LOADING, payload: true});

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        let url = '/sales/';
        const res = await axios.post(url, formData, config);

        // Get current filters from URL to preserve user's view, but go to page 1 for new sales
        const currentFilters = getParams(false); // Don't include page parameter
        dispatch(getSales(1, currentFilters));

        dispatch({
            type: ADD_SALE,
            payload: res.data,
        });

        dispatch(setAlert('Sotish yaratildi !', 'success'));

        return true;
    } catch (err) {

        dispatch(setAlert(err?.response?.data?.message || "Sotish yaratilmadi !", 'danger', ));
        if (err?.response?.data?.errors) {
            dispatch({
                type: SALE_ERROR,
                payload: err.response.data,
            });
            return err.response.data;
        } else {
            dispatch(setAlert("Sotish yaratilmadi !", 'danger'));
        }
    }
};

export const deleteSale = (deleteSaleID, getPage) => async (dispatch) => {
    dispatch(clearAlerts());

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res = await axios.delete(`/sales/${deleteSaleID}`, config);

        if (res.status === 200) {
            dispatch({
                type: REMOVE_DELETE_SALE
            });

            // Get current filters from URL to preserve user's view (including page)
            const currentFilters = getParams(true);
            const currentPage = currentFilters.page ? parseInt(currentFilters.page) : getPage;
            delete currentFilters.page; // Remove page from filters to pass separately
            dispatch(getSales(currentPage, currentFilters));

            dispatch(setAlert("Sotish o'chirildi !", 'success'));

            dispatch(clearErrors());
            return true;
        }
        return false;
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
        return false;
    }
};

export const updateSale = (updateSaleID, updateformData, getPage) => async (dispatch) => {
    dispatch(clearAlerts());
    dispatch({type: SET_LOADING, payload: true});

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res = await axios.put(`/sales/${updateSaleID}`, updateformData, config);
        
        if (res.status === 200) {
            dispatch({type: REMOVE_UPDATE_SALE});

            dispatch(setAlert('Sotish tahrirlandi !', 'success'));
            
            // Wait 1 second before refreshing the sales list
            setTimeout(() => {
                // Get current filters from URL to preserve user's view (including page)
                const currentFilters = getParams(true);
                const currentPage = currentFilters.page ? parseInt(currentFilters.page) : getPage;
                delete currentFilters.page; // Remove page from filters to pass separately
                dispatch(getSales(currentPage, currentFilters));
            }, 1000);
            
            dispatch({type: SET_LOADING, payload: false});
            return true;
        }
        dispatch({type: SET_LOADING, payload: false});
        return false;
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
        dispatch({
            type: SALE_ERROR,
            payload: {
                msg: err.response?.statusText,
                status: err.response?.status,
            },
        });
        dispatch({type: SET_LOADING, payload: false});
        return false;
    }
};

export const setDeleteSaleId = (saleID) => async (dispatch) => {

    try {
        if (saleID !== null) {
            dispatch({
                type: SET_DELETE_SALE_ID,
                payload: {
                    saleID
                }
            });

        } else {
            dispatch({
                type: REMOVE_DELETE_SALE
            });
        }

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};

export const setUpdateSaleId = (saleID) => async (dispatch) => {

    try {
        if (saleID !== null) {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            const res = await axios.get(`/sales/${saleID}`, config);

            dispatch({
                type: SET_UPDATE_SALE_ID,
                payload: res.data.data
            });
        } else dispatch({type: REMOVE_UPDATE_SALE});

    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
    }
};


export const clearErrors = () => async (dispatch) => {
    dispatch({
        type: CLEAR_ERRORS,
    });
};
